module.exports = __webpack_public_path__ + "img/t4-m7.2741016f.png";